var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import cx from 'classnames';
import styles from './Dialog.css';
import Events from 'fk-cp-shared/utils/utils';
import RippleMixin from 'fk-cp-shared/mixins/RippleMixin.js';
import { formatMessage } from '../../../utils/i18n';
import { addClassToElement, removeClassFromElement, resetBodyOverflow } from 'fk-cp-common-components/utils/domUtils';
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.show = function (children, onClose) {
            var _a;
            _this.setState({
                show: true,
                children: children,
                visible: true
            });
            requestAnimationFrame(_this.lockBodyScroll);
            _this.onCloseCb = onClose || ((_a = children) === null || _a === void 0 ? void 0 : _a.onClose);
        };
        _this.hide = function () {
            var _a, _b;
            if (_this.state.visible) {
                _this.setState({
                    visible: false
                });
                requestAnimationFrame(_this.unlockBodyScroll);
            }
            _this.setState({ show: false });
            resetBodyOverflow();
            (_b = (_a = _this).onCloseCb) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.lockBodyScroll = function () {
            _this.scrollHeight = _this.getScrollTop();
            document.body.style.top = -_this.scrollHeight + "px";
            addClassToElement(document.body, styles.noScroll);
        };
        _this.unlockBodyScroll = function () {
            removeClassFromElement(document.body, styles.noScroll);
            window.scrollTo(0, _this.scrollHeight);
            document.body.style.top = null;
        };
        _this.getScrollTop = function () {
            return window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        };
        _this.state = {
            show: false,
            buttons: [
                { text: formatMessage({ id: 'cancel' }), onClick: _this.hide },
                { text: formatMessage({ id: 'ok' }), onClick: _this.hide }
            ],
            visible: false,
            children: null
        };
        _this.handleOverlayClick = _this.handleOverlayClick.bind(_this);
        _this._hashChange = _this._hashChange.bind(_this);
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        var _a, _b;
        if ((_a = this.props.actions) === null || _a === void 0 ? void 0 : _a.buttons) {
            this.setState({
                buttons: (_b = this.props.actions) === null || _b === void 0 ? void 0 : _b.buttons
            });
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        resetBodyOverflow();
    };
    Dialog.prototype.UNSAFE_componentWillReceiveProps = function (nextprops) {
        var _a, _b;
        if ((_a = nextprops.actions) === null || _a === void 0 ? void 0 : _a.buttons) {
            this.setState({
                buttons: (_b = nextprops.actions) === null || _b === void 0 ? void 0 : _b.buttons
            });
        }
        if (nextprops.show !== this.props.show) {
            this.setState({ show: nextprops.show });
        }
    };
    Dialog.prototype.componentDidUpdate = function () {
        var _a;
        var events = new Events();
        if (this.state.show && !((_a = this.state.children) === null || _a === void 0 ? void 0 : _a.noHashRequired)) {
            location.hash = 'dialogBoxOpen';
            events.addEvent(window, 'hashchange', this._hashChange);
        }
        else {
            events.removeEvent(window, 'hashchange', this._hashChange);
        }
    };
    Dialog.prototype.handleOverlayClick = function (e) {
        var _a, _b, _c;
        if (this.props.overlayClickDisabled || ((_a = this.state.children) === null || _a === void 0 ? void 0 : _a.overlayClickDisabled)) {
            return;
        }
        if (e.target === this.overlay) {
            resetBodyOverflow();
            var overlayActions = (_c = (_b = this.state.children) === null || _b === void 0 ? void 0 : _b.actions) === null || _c === void 0 ? void 0 : _c.overlay;
            if (overlayActions && overlayActions.onClick) {
                overlayActions.onClick.call(this, e);
            }
            else {
                this.hide();
            }
        }
    };
    Dialog.prototype._hashChange = function () {
        if (location.hash === '') {
            this.hide();
        }
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var contentClass = {}, overlayClass = {};
        overlayClass[styles['overlay']] = true;
        overlayClass[styles['easein']] = true;
        contentClass[styles['contentDialog']] = true;
        contentClass[styles['content-top-align']] = this.props.isTopAlign;
        document.body.style.overflow = this.state.show ? 'hidden' : 'auto';
        if (this.state.show) {
            var zIndex = ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.zIndex) || 1000;
            return (<div className={styles['fk-dialog']} key="dialog" style={{ zIndex: zIndex }}>
                    <div className={cx(overlayClass)} ref={function (e) { return (_this.overlay = e); }} onClick={this.handleOverlayClick} data-test-id="dialog-container">
                        <div className={cx(contentClass)} data-test-id="dialog-content">
                            {this.props.title ? <h3 className={styles['title']}>{this.props.title}</h3> : null}
                            {this.props.message && <div className={styles['message']}>{this.props.message}</div>}
                            <div className={styles['children']}>{this.state.visible ? (_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d.children : null}</div>
                            {this.state.visible && ((_g = (_f = (_e = this.state.children) === null || _e === void 0 ? void 0 : _e.actions) === null || _f === void 0 ? void 0 : _f.buttons) === null || _g === void 0 ? void 0 : _g.length) > 0 && (<div className={cx(styles['buttonsDialog'], this.props.buttonClass ? this.props.buttonClass : '', ((_j = (_h = this.state) === null || _h === void 0 ? void 0 : _h.children) === null || _j === void 0 ? void 0 : _j.buttonClass) ? (_l = (_k = this.state) === null || _k === void 0 ? void 0 : _k.children) === null || _l === void 0 ? void 0 : _l.buttonClass : '')}>
                                    {this.state.children.actions.buttons.map(function (action, k) {
                var _a, _b, _c;
                var clickHandler = (action.onClick && _this.clickHandler.bind(_this, action.onClick)) ||
                    _this.clickHandler.bind(_this, _this.hide);
                var btnClass = {};
                btnClass[styles['actionDialog']] = ((_b = (_a = _this.state) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.customButtonStyle) ? false : true;
                btnClass[styles['blue']] =
                    action.blueTextColor !== undefined ? action.blueTextColor : true;
                return (<button key={k} data-test-id={"dialog-" + k + "-button"} className={cx(btnClass)} style={(_c = action) === null || _c === void 0 ? void 0 : _c.textStyle} onClick={clickHandler}>
                                                {action.text}
                                            </button>);
            }, this)}
                                </div>)}
                        </div>
                    </div>
                </div>);
        }
        return null;
    };
    Dialog.prototype.clickHandler = function (action, e) {
        e.stopPropagation();
        RippleMixin.createRipple(e, e.currentTarget, styles['ink'], styles['animate']);
        action();
    };
    return Dialog;
}(React.Component));
export default Dialog;
